export default "__VITE_ASSET__DW$XgneW__"